import { render, staticRenderFns } from "./RecordsSummary.vue?vue&type=template&id=2169dfdc&scoped=true"
import script from "./RecordsSummary.vue?vue&type=script&lang=ts"
export * from "./RecordsSummary.vue?vue&type=script&lang=ts"
import style0 from "./RecordsSummary.vue?vue&type=style&index=0&id=2169dfdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2169dfdc",
  null
  
)

export default component.exports